/**
 * 出图主提交那一刻要落的**正式报价单**参数(修复波 0926 · 代理 D)。
 *
 * ★为什么要有它:`handleGenerate` 早就收了一个 `quoteId` 参数(确认卡那张单),
 *   却**从没把它放进建单请求**;没弹确认卡的那条路(最常走的直接点生成)连单都没取。
 *   于是出图主路整条落在后端 `poster_task_without_quote` 软着陆 —— settle 时 raw_usage 一旦
 *   缺 tier 就退回 SKU 级 ×1.6 旧口径(0903「报价 28 实扣 40」同形,api
 *   `CreateQuoteBinding0926IT` 有真库负对照)。
 *
 * ★张数必须与后端 `PosterService.computeRequestedCount` **同一份推导**:
 *   组图 = 爆点数(≤6;分步 cover 阶段 = 1)/ 多比例 = 去重后的比例数 / 其余 = 张数。
 *   单上的张数和真派发张数对不上,「报价即合同」就会按错的数兑现(多收或少收都是事故)。
 * ★档位用**提交时裁决完**的那一档(带参考图强制 1K 之后的值),不是 form 上的原值。
 */
import { SKU, imageVariant } from "@/entities/pricing/model/priceBook";
import type { QuoteParams } from "@/entities/pricing/api/pricingService";

export interface SubmitQuoteInput {
  provider: string | null | undefined;
  tier: string;
  groupPoints: readonly unknown[] | null;
  groupStage?: "cover" | "all";
  ratioSet: readonly string[] | null;
  count: number;
}

/** 与后端 computeRequestedCount 同口径的张数。 */
export function submitQuoteQty({
  groupPoints,
  groupStage,
  ratioSet,
  count,
}: Omit<SubmitQuoteInput, "provider" | "tier">): number {
  if (groupPoints && groupPoints.length > 0) {
    return groupStage === "cover" ? 1 : Math.min(groupPoints.length, 6);
  }
  if (ratioSet && ratioSet.length > 0) {
    return new Set(ratioSet).size;
  }
  return count;
}

/** 报不出参数(没有 provider / 张数为 0)→ null:不取单,后端按软着陆处理,不阻断提交。 */
export function submitQuoteParams(input: SubmitQuoteInput): QuoteParams | null {
  const qty = submitQuoteQty(input);
  if (!input.provider || qty <= 0) return null;
  return {
    skuCode: SKU.posterImage,
    variantKey: imageVariant(input.provider, input.tier),
    qty,
  };
}
